<template>
  <div class="button-wrapper">
    <button
      :class="`${type}-button`"
      :disabled="disabled"
      @click="toggleDropdown"
    >
      <div class="left-side">
        <i class="material-icons md-18">{{ icon || button[type].icon }}</i
        >{{ text || button[type].text }}
      </div>

      <div class="dropdown-icon-wrapper">
        <icon class="dropdown-icon" @click="toggleDropdown"
          >arrow_drop_down</icon
        >
      </div>
    </button>
    <SlideYUpTransition>
      <div
        v-if="showDropdown"
        :class="['button-dropdown', 'shadow-down']"
        v-click-outside="toggleDropdown"
        @click="toggleDropdown"
      >
        <div
          class="option"
          @click="$emit('click', { showSaveAsNewButton: false })"
        >
          Save &amp; Update
        </div>
        <div
          class="option"
          @click="$emit('click', { showSaveAsNewButton: true })"
        >
          Save as New
        </div>
      </div>
    </SlideYUpTransition>
  </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";
import vClickOutside from "v-click-outside";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    type: String,
    text: String,
    disabled: Boolean,
    icon: String,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      button: {
        primary: {
          icon: "save",
          text: "Save",
        },
        info: {
          icon: "add",
          text: "Add",
        },
        secondary: {
          icon: "clear",
          text: "Cancel",
        },
      },
      showDropdown: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};
</script>
<style lang="scss" scoped>
.button-wrapper {
  position: relative;

  .button {
    outline: none !important;
    background: var(--color-primary-light);
    border: 0;
    border-radius: 3px;
    color: var(--color-primary);
    font-weight: bold;
    transition: 0.3s all ease-in-out;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 0;
    z-index: 100;
    overflow: hidden;

    .left-side {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0 10px 15px;
    }

    i {
      margin-right: 10px;
    }

    .dropdown-icon-wrapper {
      align-self: stretch;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      background: rgba(0, 0, 0, 0.2);
      transition: 0.3s all ease-in-out;

      .dropdown-icon {
        margin: 0;
        align-self: stretch;
        display: flex;
        align-items: center;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }

    &:hover {
      cursor: pointer;
      background: var(--color-primary);
      color: var(--color-secondary);
    }

    &:active {
      transform: scale(0.9);
    }
  }

  .primary-button {
    @extend .button;
    background: var(--color-primary);
    color: var(--color-secondary);

    &:hover {
      background: var(--color-primary-dark);
      color: var(--color-secondary);
    }

    &:disabled {
      background: var(--font-color-unselected);
      color: var(--font-color);

      &:hover {
        background: var(--font-color-unselected);
        color: var(--font-color);
        cursor: not-allowed;
      }
    }
  }

  .secondary-button {
    @extend .button;
    background: var(--font-color-unselected);
    color: var(--font-color);
    margin-right: 10px;

    &:hover {
      background: var(--border-color);
      color: var(--font-color);
    }

    &.disabled {
      background: var(--font-color-unselected);
      color: var(--font-color);

      &:hover {
        background: var(--font-color-unselected);
        color: var(--font-color);
        cursor: not-allowed;
      }
    }
  }

  .button-dropdown {
    position: absolute;
    width: 150%;
    background: var(--color-secondary);
    z-index: 99;
    max-height: 300px;
    overflow: auto;
    top: calc(100% + 10px);
    right: 0;
    border-radius: 5px;
    border: 1px solid var(--border-color);

    .option {
      padding: 15px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--border-color);

      &:last-child {
        border-bottom: none;
      }
      &.active {
        background-color: var(--color-primary-light);
        color: var(--color-primary);
      }

      &:hover {
        background-color: var(--color-primary-light);
        cursor: pointer;
      }

      p {
        margin: 0;
      }
    }
  }
}
</style>
